import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/layout/AppShell';
import { Toaster } from './components/ui/sonner';
import './App.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Products from './pages/Products';
import Packages from './pages/Packages';
import Quotations from './pages/Quotations';
import QuotationDetail from './pages/QuotationDetail';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import Payments from './pages/Payments';
import Receivables from './pages/Receivables';
import FollowUps from './pages/FollowUps';
import Reports from './pages/Reports';
import ImportExport from './pages/ImportExport';
import SettingsPage from './pages/Settings';

const Shell = ({ children }) => (
  <ProtectedRoute>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  useEffect(() => {
    document.title = 'Glowing Production | e-Invoicing App';
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="dark">
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
            <Route path="/clients" element={<Shell><Clients /></Shell>} />
            <Route path="/clients/:id" element={<Shell><ClientDetail /></Shell>} />
            <Route path="/products" element={<Shell><Products /></Shell>} />
            <Route path="/packages" element={<Shell><Packages /></Shell>} />
            <Route path="/quotations" element={<Shell><Quotations /></Shell>} />
            <Route path="/quotations/:id" element={<Shell><QuotationDetail /></Shell>} />
            <Route path="/invoices" element={<Shell><Invoices /></Shell>} />
            <Route path="/invoices/:id" element={<Shell><InvoiceDetail /></Shell>} />
            <Route path="/payments" element={<Shell><Payments /></Shell>} />
            <Route path="/receivables" element={<Shell><Receivables /></Shell>} />
            <Route path="/receivables/:id" element={<Shell><Receivables /></Shell>} />
            <Route path="/followups" element={<Shell><FollowUps /></Shell>} />
            <Route path="/reports" element={<Shell><Reports /></Shell>} />
            <Route path="/import-export" element={<Shell><ImportExport /></Shell>} />
            <Route path="/settings" element={<Shell><SettingsPage /></Shell>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
